import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import HeadsetInterface from 'resources/headsets/headset-interface';
var EposHeadset = /*#__PURE__*/function (_HeadsetInterface) {
  function EposHeadset(deviceInfo) {
    var _this;
    _classCallCheck(this, EposHeadset);
    _this = _callSuper(this, EposHeadset, [deviceInfo]);
    _defineProperty(_this, "attachCallbacks", function (callbacks) {
      _this.callbacks = callbacks(_this.id);
      _this.sdk.on('EndCall', _this.callbacks.onHangup);
      _this.sdk.on('RejectCall', _this.callbacks.onHangup);
      _this.sdk.on('AcceptCall', _this.callbacks.onAcceptCall);
      _this.sdk.on('MuteMicrophone', function (mute) {
        if (mute) {
          _this.callbacks.onMuteEvent();
        } else {
          _this.callbacks.onUnmuteEvent();
        }
      });
      _this.sdk.on('HoldCall', _this.callbacks.onHoldCall);
      _this.sdk.on('ResumeCall', _this.callbacks.onUnholdCall);
      // Redial and Offhook not implemented at the moment
      // Redial would redial the last called number
      // Offhook would prepare the user for making an outgoing call, in traditional phones by playing
      // a dial tone. In our case, maybe open the dialpad or something.
      //this.sdk.on('Redial', );
      //this.sdk.on('Offhook', );

      return _this;
    });
    _this.sdk = deviceInfo.sdk;
    return _this;
  }
  _inherits(EposHeadset, _HeadsetInterface);
  return _createClass(EposHeadset, [{
    key: "incomingCallImpl",
    value: function incomingCallImpl(callId) {
      this.sdk.SendIncomingCallEvent(callId);
    }
  }, {
    key: "outgoingCallImpl",
    value: function outgoingCallImpl(callId) {
      this.sdk.SendOutgoingCallEvent(callId);
    }
  }, {
    key: "confirmCallImpl",
    value: function confirmCallImpl(callId) {
      this.sdk.SendActiveCallEvent(callId);
    }
  }, {
    key: "endCallImpl",
    value: function endCallImpl(callId) {
      this.sdk.SendEndCallEvent(callId);
    }
  }, {
    key: "holdCallImpl",
    value: function holdCallImpl(callId) {
      this.sdk.SendHoldCallEvent(callId);
    }
  }, {
    key: "resumeCallImpl",
    value: function resumeCallImpl(callId) {
      this.sdk.SendUnholdCallEvent(callId);
    }
  }, {
    key: "muteCallImpl",
    value: function muteCallImpl() {
      this.sdk.SendMuteStatus(true);
    }
  }, {
    key: "unmuteCallImpl",
    value: function unmuteCallImpl() {
      this.sdk.SendMuteStatus(false);
    }
  }, {
    key: "onDisconnectImpl",
    value: function onDisconnectImpl() {
      this.sdk.SendTerminateEvent();
    }
  }, {
    key: "userUnavailable",
    value: function userUnavailable() {
      this.sdk.SendPresenceEvent('Away');
    }
  }, {
    key: "userAvailable",
    value: function userAvailable() {
      this.sdk.SendPresenceEvent('Available');
    }
  }]);
}(HeadsetInterface);
export { EposHeadset as default };